import React from "react";
import Header from "../components/Header"; // include your header component
import Footer from "./Footer";

export default function PrivacyPolicy() {
  return (
    <>
      <Header hideBookButton={false} />
      <div className="pt-20 min-h-screen bg-[#204080] text-blue-100 px-6 py-12">
        <div className="max-w-4xl mx-auto">
               <h1 className="text-4xl font-bold text-white mb-6 border-b border-white/30 pb-2 text-center">
  Privacy Policy
</h1>

          <p className="mb-6 text-blue-200">
            Visakha Physiotherapy & Jasti Chiropractic ("VPJC") respects your privacy and is committed
            to protecting your personal information. This Privacy Policy explains how we collect, use,
            and safeguard your data when you use our website.
          </p>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">1. Information We Collect</h2>
            <ul className="list-disc pl-6 space-y-1 text-blue-200">
              <li>Personal details like name, phone number, and email during appointment booking.</li>
              <li>Login details (email and password) for authenticated users.</li>
              <li>Newsletter email addresses for updates and tips.</li>
              <li>Job application details including name, email, phone, and resume file.</li>
              <li>Consultation type and branch preferences.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-1 text-blue-200">
              <li>To manage appointments and send booking confirmations or reminders.</li>
              <li>To send health tips and clinic updates (newsletter).</li>
              <li>To process job applications.</li>
              <li>To respond to contact form submissions.</li>
              <li>To improve our services and communication.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">3. Data Storage & Security</h2>
            <p className="text-blue-200">
              We use <strong>Firebase</strong> for secure data storage and authentication, and
              <strong> Zoho SMTP</strong> for sending automated emails. All data is transmitted over
              HTTPS. Role-based access control ensures only authorized staff can view or manage data.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">4. Third-Party Sharing</h2>
            <p className="text-blue-200">
              We do not sell or share your data with third parties. Information is used solely for the
              purposes mentioned above.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">5. Cookies and Tracking</h2>
            <p className="text-blue-200">
              We do not use cookies or analytics tools on our website at this time.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">6. Children’s Privacy</h2>
            <p className="text-blue-200">
              Our services are intended for individuals 18 years and older. We do not knowingly collect
              data from minors.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">7. Data Retention</h2>
            <p className="text-blue-200">
              We retain user data only as long as necessary to provide services or comply with legal requirements.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-semibold text-white mb-2">8. Your Rights</h2>
            <p className="text-blue-200">
              You may request to access, update, or delete your information at any time by contacting us
              at <a href="mailto:contact@jastiphysiochiro.com" className="text-white underline">contact@jastiphysiochiro.com</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-2">9. Updates to This Policy</h2>
            <p className="text-blue-200">
              We may update this Privacy Policy periodically. Updates will be reflected on this page.
            </p>
          </section>

          <p className="mt-8 text-blue-200">
            <strong>Last Updated:</strong> October 2025
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}